import prepareComponent from "@bluframe/grapple/prepareComponent"
import { Image } from "@bluframe/mightychroma-mightytool-frontend-types"
import { UseComboboxGetItemPropsReturnValue } from "downshift"
import { MouseEventHandler } from "react"

import Suggestion from "./Suggestion"

export type SuggestionPillTone =
  | "default"
  | "info"
  | "success"
  | "warning"
  | "error"

export interface SuggestionPill {
  id: string
  label: string
  tone?: SuggestionPillTone
}

export interface Props {
  ariaLabel?: string
  id?: string
  image?: Image
  isLoading?: boolean
  itemProps: UseComboboxGetItemPropsReturnValue
  pills?: SuggestionPill[]
  subtitlePrimary?: string
  subtitleSecondary?: string
  title?: string

  onSuggestionClick?: (id: string, name: string) => void
}

export interface ComponentProps extends Omit<Props, "onSuggestionClick"> {
  onClick: MouseEventHandler
}

export const usePrepareComponent = (props: Props): ComponentProps => {
  const onClick: MouseEventHandler = (event) => {
    // Downshift onClick
    props.itemProps.onClick?.(event)

    // onSuggestionClick
    if (props.id) {
      props.onSuggestionClick?.(props.id, props.title ?? "")
    }
  }

  return {
    ...props,
    onClick
  }
}

export default prepareComponent<Props, ComponentProps>(usePrepareComponent)(
  Suggestion
)
